import * as React from "react";
import * as advance from "./style.module.scss";
export const Advance = () => {
  return (
    <section className={advance.advance}>
      <div className="container">
        <h2>Мы — Центр образовательных технологий Advance</h2>
        <div className={`row ${advance.row}`}>
          <div className={`col ${advance.col}`}>
            <p className={advance.num}>с&nbsp;2009&nbsp;года</p>
            <p>
              учим людей раскрывать и&nbsp;развивать свой интеллектуальный потенциал, повышать личную эффективность
            </p>
          </div>
          <div className={`col ${advance.col}`}>
            <p className={advance.num}>1,6 млн</p>
            <p>
              человек приняли участие в&nbsp;наших курсах и&nbsp;семинарах
            </p>
          </div>
          <div className={`col ${advance.col}`}>
            <p className={advance.num}>85 000</p>
            <p>
              человек прошли наши полные курсы
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
